const env = process.env.NODE_ENV || "development";

const apiEnvironment = {
  development: {
        api: "https://melinhsmartcity-api.cgis.asia/",
        media_url: "https://melinhsmartcity-api.cgis.asia/",
        domainAdminSide: "http://localhost:3000",
        domainUserSide: "http://localhost:3001",
        domainName: "",
        workSpace: "dttm_melinh",
        wmsBaseLink: "https://geo.cgis.asia/geoserver/dttm_melinh/wms/",
  },
  production: {
      api: "https://melinhsmartcity-api.cgis.asia/",
      media_url: "https://melinhsmartcity-api.cgis.asia/",
      domainAdminSide: "https://admin.melinhsmartcity.cgis.asia",
      domainUserSide: "https://melinhsmartcity.cgis.asia",
      domainName: "melinhsmartcity.cgis.asia",
      workSpace: "dttm_melinh",
      wmsBaseLink: "https://geo.cgis.asia/geoserver/dttm_melinh/wms/",
  },
};

module.exports = apiEnvironment[env];
